import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ReturnUrlService } from '../../services/return-url.service';
import { DesignAngularKitModule } from 'design-angular-kit';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-back-link',
  standalone: true,
  imports: [DesignAngularKitModule],
  template: `
    <div class="it-link-wrapper">
      <a href="#" (click)="goBack($event)" [class]="cssClass">
        <it-icon class="me-1" [name]="'arrow-left'" color="primary" size='xs'></it-icon>
        {{ label }}
      </a>
    </div>
  `
})
export class BackLinkComponent {
  @Input() fallbackUrl: string = '';
  @Input() label = 'Torna indietro';
  @Input() cssClass = ''

  constructor(
    private router: Router,
    private returnUrlService: ReturnUrlService,
    private authSevice: AuthService
  ) {}

  ngOnInit() {
    this.fallbackUrl = this.authSevice.isOperatoreMmg ? '/dashboard-mmg' : '/dashboard';
  }

  goBack(event: Event): void {
    event.preventDefault();
    const url = this.returnUrlService.get() ?? this.fallbackUrl;
    this.returnUrlService.clear();
    this.router.navigateByUrl(url);
  }
}
